<template>
  <el-card shadow="never" class="aui-card--fill">
    <el-form :inline="true"
             :model="tableData">
      <el-row>
        <el-col :span="7">
          <el-form-item label="部门中文名称:">
            <el-input v-model="tableData.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="部门英文名称">
            <el-input v-model="tableData.nameEn"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="部门代码：">
            <el-input v-model="tableData.code"
                      clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item>
            <el-button size="mini" @click="selectPosition">{{'选择岗位'}}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="7">
          <el-form-item label="部门图标：">
            <el-input v-model="tableData.icon"
                      clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-button size="small" type="text" >{{'展开'}}</el-button>
    <el-button size="small" type="text" >{{'收起所有'}}</el-button>
    <el-table
      :data="tableData.list"
      style="width: 100%;margin-bottom: 20px;"
      row-key="id"
      border
      :default-expand-all="isExpand"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column
        prop="positionName"
        label="岗位名称">
      </el-table-column>
      <el-table-column
        prop="positionCode"
        label="岗位代码"  align="center">
      </el-table-column>
      <el-table-column
        align="center"
        width="100"
        :label="$t('handle')">
        <template slot-scope="scope">
          <el-dropdown trigger="click" placement="bottom">
              <span class="el-dropdown-link">
                {{ $t('handle') }}<em class="el-icon-caret-bottom el-icon--right"></em>
              </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item >{{'删除'}}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="选择岗位"  :visible.sync="isShowDialog" top="15vh" width="50%" :close-on-click-modal="false">
      <el-form :inline="true" :model="positionForm">
        <el-row>
          <el-col :span="6">
            <el-form-item></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="选择岗位">
              <el-select clearable collapse-tags v-model="positionForm.positionId">
                <el-option
                  v-for="item in positionList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item></el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item>
              <el-button size="mini" @click="savePosition">{{'保存'}}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </el-card>
</template>

<script>
export default {
  data () {
    return {
      fileList: [],
      isExpand: true,
      isShowDialog: false,
      tableData: {
        id: 2,
        name: '售后',
        nameEn: '售后EN',
        code: 'BMW_AFTER_SALE',
        icon: '',
        version: '',
        list: [{
          id: 1,
          positionName: '销售经理/总监',
          positionCode: '221',
          children: [{
            id: 31,
            positionName: '销售主管/展厅经理',
            positionCode: '222',
            children: [{
              id: 40,
              positionName: '新车销售顾问',
              positionCode: '233'
            }, {
              id: 41,
              positionName: '产品精英',
              positionCode: '234'
            }, {
              id: 42,
              positionName: '销售助理',
              positionCode: '235'
            }]
          }, {
            id: 32,
            positionName: 'BMW NEW 销售经',
            positionCode: '242',
            children: [{
              id: 50,
              positionName: 'BMW NEW 销售顾问',
              positionCode: '243'
            }, {
              id: 51,
              positionName: '充电服务顾问',
              positionCode: '244'
            }]
          }, {
            id: 33,
            positionName: '大客户销售经理',
            positionCode: '252'
          }]
        }]
      },
      positionForm: {
        positionId: ''
      },
      positionList: [{ value: '销售内训师', label: '销售内训师' }, { value: '销售计划专员', label: '销售计划专员' }, { value: '预约专员', label: '预约专员' }]
    }
  },
  activated () {
    console.log('activated')
  },
  methods: {
    handleRemove (file, fileList) {
      console.log(file, fileList)
    },
    handlePreview (file) {
      console.log(file)
    },
    handleProgress (event, file, fileList) {
      console.log(file)
    },
    // 选择岗位
    selectPosition () {
      this.isShowDialog = true
    },
    savePosition () {
      this.isShowDialog = false
    }
  }
}
</script>
<style>
  .cell .el-table__placeholder {
    position: relative;
    margin-left: 20px;
  }
</style>
